'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/world/World.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var WorldIcon = (props) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M12.8304 3.47294C12.4697 3.09148 12.1887 2.99998 12 2.99998C11.8113 2.99998 11.5303 3.09148 11.1696 3.47294C10.8068 3.85651 10.4341 4.46521 10.1001 5.3003C9.51869 6.7537 9.11393 8.74347 9.02056 11L14.9794 11C14.8861 8.74347 14.4813 6.7537 13.9 5.3003C13.5659 4.46521 13.1932 3.85651 12.8304 3.47294Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M14.9794 13L9.02056 13C9.11393 15.2565 9.51869 17.2463 10.1001 18.6997C10.4341 19.5348 10.8068 20.1435 11.1696 20.527C11.5303 20.9085 11.8113 21 12 21C12.1887 21 12.4697 20.9085 12.8304 20.527C13.1932 20.1435 13.5659 19.5348 13.9 18.6997C14.4813 17.2463 14.8861 15.2565 14.9794 13Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M7.019 11C7.11321 8.53281 7.55341 6.28174 8.2431 4.55752C8.59135 3.68688 9.01892 2.91104 9.52993 2.30737C5.51446 3.32757 2.46862 6.77743 2.04938 11H7.019Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M2.04938 13H7.019C7.11321 15.4672 7.55341 17.7182 8.2431 19.4424C8.59135 20.3131 9.01892 21.0889 9.52993 21.6926C5.51446 20.6724 2.46862 17.2225 2.04938 13Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M16.981 13H21.9506C21.5314 17.2225 18.4855 20.6724 14.4701 21.6926C14.9811 21.0889 15.4086 20.3131 15.7569 19.4424C16.4466 17.7182 16.8868 15.4672 16.981 13Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M21.9506 11C21.5314 6.77743 18.4855 3.32757 14.4701 2.30737C14.9811 2.91105 15.4086 3.68688 15.7569 4.55752C16.4466 6.28174 16.8868 8.53281 16.981 11H21.9506Z",
            fill: "currentColor"
          }
        )
      ]
    })
  );
};

// src/world/WorldOutlined.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var WorldOutlinedIcon = (props) => {
  return /* @__PURE__ */ jsx2(
    "svg",
    __spreadProps(__spreadValues({
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx2(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.35513 7.50016H4.67556C4.73114 5.93697 5.04559 4.51185 5.54223 3.43092C5.65569 3.18399 5.78308 2.94653 5.924 2.72585C3.9692 3.4959 2.54562 5.3213 2.35513 7.50016ZM8.00004 1.3335C4.31814 1.3335 1.33337 4.31826 1.33337 8.00016C1.33337 11.6821 4.31814 14.6668 8.00004 14.6668C11.6819 14.6668 14.6667 11.6821 14.6667 8.00016C14.6667 4.31826 11.6819 1.3335 8.00004 1.3335ZM8.00004 2.3335C7.53142 2.3335 6.94712 2.76844 6.45091 3.84842C6.02333 4.77904 5.7315 6.05665 5.67623 7.50016H10.3238C10.2686 6.05665 9.97675 4.77904 9.54917 3.84842C9.05296 2.76844 8.46866 2.3335 8.00004 2.3335ZM11.3245 7.50016C11.2689 5.93697 10.9545 4.51185 10.4578 3.43092C10.3444 3.18399 10.217 2.94653 10.0761 2.72585C12.0309 3.4959 13.4545 5.3213 13.645 7.50016H11.3245ZM10.3238 8.50016H5.67623C5.7315 9.94368 6.02333 11.2213 6.45091 12.1519C6.94712 13.2319 7.53142 13.6668 8.00004 13.6668C8.46866 13.6668 9.05296 13.2319 9.54917 12.1519C9.97675 11.2213 10.2686 9.94368 10.3238 8.50016ZM10.0761 13.2745C10.217 13.0538 10.3444 12.8163 10.4578 12.5694C10.9545 11.4885 11.2689 10.0634 11.3245 8.50016H13.645C13.4545 10.679 12.0309 12.5044 10.0761 13.2745ZM5.92401 13.2745C5.78308 13.0538 5.65569 12.8163 5.54223 12.5694C5.04559 11.4885 4.73114 10.0634 4.67556 8.50016H2.35513C2.54562 10.679 3.9692 12.5044 5.92401 13.2745Z",
          fill: "currentColor"
        }
      )
    })
  );
};

export {
  WorldIcon,
  WorldOutlinedIcon
};
//# sourceMappingURL=chunk-PVMC7TFK.mjs.map